<template>
  <div
    class="checkbox-input"
    @mouseover="(!hovered ? hover(true) : null)"
    @mouseleave="hover(false)"
    @click="toggleValue"
  >
    <input
      type="checkbox"
      v-model="inputValue"
      disabled
      @change="updateValue"
    >
    <div
      class="control__indicator"
      :style="{
        'background-color': checkBoxColor
      }"
    />
  </div>
</template>

<script>
export default {
  name: 'CheckboxInput',
  data () {
    return {
      showDebugLogs: false,
      hovered: false,
      inputValue: false
    }
  },
  props: {
    value: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    forcedHover: {
      default: false,
      type: Boolean
    },
    defaultColor: {
      default: '#58585b',
      type: String
    },
    disabledColor: {
      default: '#dddddd',
      type: String
    },
    hoverColor: {
      default: '#212121',
      type: String
    }
  },
  methods: {
    hover (value) {
      let self = this
      self.hovered = self.forcedHover ? self.forcedHover : value
    },
    toggleValue () {
      let self = this
      if (self.disabled !== true) {
        self.inputValue = !self.inputValue
        self.updateValue()
      }
    },
    updateValue () {
      let self = this
      if (self.showDebugLogs) {
        console.log(self.inputValue)
      }
      self.$emit('change', self.inputValue)
    }
  },
  computed: {
    checkBoxColor () {
      let self = this
      return self.inputValue ? '#00bbd5' : self.disabled ? '#eeeeee' : (self.hovered ? '#dddddd' : '#dddddd')
    },
    textColor () {
      let self = this
      return self.disabled ? self.disabledColor : (self.hovered ? self.hoverColor : self.defaultColor)
    }
  },
  watch: {
    value: function () {
      let self = this
      self.inputValue = self.value
    },
    forcedHover () {
      let self = this
      self.hover(self.forcedHover)
    }
  },
  created () {
    let self = this
    self.inputValue = self.value
    self.hover(self.forcedHover)
  }
}
</script>

<style lang="scss" scoped>
  .checkbox-input {
    cursor: pointer;
    position: relative;
  }

  input[type="checkbox"] {
    float: left;
    width: 16px;
    height: 16px;
    opacity: 0;
    margin: 0;
  }

  .control__indicator {
    position: absolute;
    height: 16px;
    width: 16px;
    border-radius: 1px;
  }
  .checkbox-input input:checked ~ .control__indicator {
    border: 1px solid #00bbd5;
    width: 16px;
    height: 16px;
    border-radius: 2px;
  }
  .control__indicator:after {
    content: '';
    position: absolute;
    display: none;
  }
  .checkbox-input input:checked ~ .control__indicator:after {
    display: block;
  }
  .checkbox-input .control__indicator:after {
    width: 5px;
    height: 10px;
    left: 4px;
    top: -1px;
    border: solid #f7f7f7;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

</style>



// WEBPACK FOOTER //
// src/components/Checkbox/CheckboxInput.vue